import React, { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { connect } from "react-redux";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Radio, Paper, Tooltip } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import StackedBarChart from "../StackedBarChart";
import GroupedBarLineChart from "../GroupedBarLineChart";
import GroupedBarMultipleLineChart from "../GroupedBarMultipleLineChart";
import { useSelector } from "react-redux";
import DoBarChart from "../DoBarChart";
import { COFMockData, RedeployCost } from "../../../../data/mockdata";
import DPBarChart from "../DPBarChart";
import DPGroupedBarLineChart from "../DPGroupedBarLineChart";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BarChart from "../BarChart";
import DPBarMultiple from "../DPBarMultiple";
import GraphService from "../../../../services/console_services/Graph";
import Loading from "../../Loading";
import { setModuleTabIndex } from "../../../../store/Actions";
import CustomScrollButton from "../../ReusableComponents/CustomTabScrollButton";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((_theme) => ({
  root: {
    flexGrow: 1,
    dispatch: "flex",
    padding: "10px",
  },
  paper: {
    boxShadow:
      "5px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10) !important",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "58vh",
    width: "100%",
    position: "relative",
    top: 0,
    left: 0,
  },
  select: {
    borderColor: "transparent",
    borderStyle: "none",
    height: "30px",
    width: "120px",
    borderRadius: "4px !important",
    background: "var(--Neutral-Colors-White, #FFF)",
    fontSize: "14px !important",
    color: "#404041 !important",
    "&.MuiOutlinedInput-root": {
      margin: "0px 17px",
    },
  },
  main: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0px 10px",
  },
  appBar: {
    padding: "10px",
  },
  tab: {
    background: "#FFF",
    boxShadow:
      "0px 2px 4px 0px rgba(0, 0, 0, 0.10), 0px 4px 12px 0px rgba(0, 0, 0, 0.10)",
    flex: 1,
    minHeight: "30px",
    borderRadius: "8px",
  },
  activeTabs: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    fontWeight: "500",
    textTransform: "none",
    borderRight: "1px solid #92949747",
    minHeight: "30px",
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Nestle_Blue, #0067A1)",
  },
  inActiveTabs: {
    color: "#59595A",
    fontFamily: "Poppins, sans-serif",
    fontSize: "13px",
    textTransform: "none",
    minHeight: "30px",
    opacity: 1,
    border: "1px solid var(--Neutral-Colors-Off-White, #E6E7E8)",
    background: "var(--Neutral-Colors-White, #FFF)",
  },
  indicator: {
    display: "none",
  },
  filter: {
    fontSize: "14px",
    margin: "0px 2px",
  },
}));

const GraphViewSNO_DOM = ({
  tabIndex,
  Module,
  Network,
  DC,
  Products,
  Division,
  PL3,
  graphViewTabList,
  date,
  applyFilter,
  role,
  moduleTabIndexChange,
}) => {
  const classes = useStyles();
  const { instance } = useMsal();
  const [selectedRadioValue, setSelectedRadioValue] = useState("Network");
  const [topOrBottomValue, setTopOrBottomValue] = useState("Top");
  const [countValue, setCountValue] = useState("5");
  const tabValue = useSelector((state) => state?.tabs?.moduleTabIndex);
  // const [categoryList, setCategoryList] = useState("");
  const categoryList = "";
  const [graphData, setGraphData] = useState([]);
  const [graphDate, setGraphDate] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeTab = graphViewTabList.filter(
    (item) => item.index === tabValue,
  )[0].name;
  const countList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const getGraphData = (params) => {
    setLoading(true);
    GraphService.getGraph(params, instance)
      .then((data) => {
        if (data?.data) {
          setGraphData(data?.data?.data ? data?.data?.data : data?.data);
          setGraphDate(data.data);
        }
      })
      .catch((error) => console.error("Error:", error))
      .finally(() => setLoading(false));
  };

  const referenceDate = new Date(date?.[0]);
  referenceDate.setDate(referenceDate.getDate() - 30);
  const startDate = referenceDate.toISOString().split("T")[0];

  const memoizedParams = useMemo(() => {
    const isPreviousMonth =
      activeTab === "Throughput" && topOrBottomValue !== "Top";
    return {
      section: Module,
      type: graphViewTabList[tabValue]?.value,
      name: selectedRadioValue,
      arrangements:
        activeTab === "Outbound Utilization"
          ? topOrBottomValue === "Top"
            ? "Next"
            : topOrBottomValue
          : topOrBottomValue,
      value: countValue,
      X_Axis: selectedRadioValue,
      ...(activeTab === "Throughput" && { isPreviousMonth }),
      Level: role,
      filter: {
        RecommendedDC: DC,
        Network:
          Network && Network.length
            ? Network
            : activeTab === "Throughput"
              ? ["AMBIENT"]
              : Network,
        PL3: PL3,
        Division: Division,
        Products: Products,
        startDate: date?.[0],
        endDate: date?.[1],
      },
    };
  }, [
    Module,
    tabValue,
    selectedRadioValue,
    topOrBottomValue,
    countValue,
    role,
    DC,
    Network,
    PL3,
    Division,
    Products,
    date,
    activeTab,
    startDate,
  ]);

  useEffect(() => {
    // Conditional check to avoid unnecessary API calls
    if (
      !memoizedParams.section ||
      !memoizedParams.type ||
      !memoizedParams.name ||
      !memoizedParams.filter.startDate ||
      !memoizedParams.filter.endDate
    ) {
      return;
    }
    getGraphData(memoizedParams);
  }, [memoizedParams, applyFilter]);

  const handleChange = (_event, newValue) => {
    moduleTabIndexChange(newValue);
    setSelectedRadioValue("Network");
    setTopOrBottomValue("Top");
    setCountValue("5");
  };
  const handleRadioChange = (selectedFilter) => {
    setSelectedRadioValue(selectedFilter);
  };

  const handleTopBottomChange = (event) => {
    setTopOrBottomValue(event.target.value);
  };

  const handleCountChange = (event) => {
    setCountValue(event.target.value);
  };
  const renderChart = () => {
    const chartProps = {
      graphData,
      categoryList,
      showAnnotation: true,
      activeTab,
    };

    if (Module === "SNO") {
      if (activeTab === "COF") {
        return <StackedBarChart {...chartProps} activeTab={activeTab} />;
      }

      if (["Cost per Case", "Cost Reductions"].includes(activeTab)) {
        return (
          <BarChart
            {...chartProps}
            yAxisTitle={
              activeTab === "Cost per Case"
                ? "Cost per Case"
                : "Cost Reductions"
            }
            showAnnotation={activeTab === "Cost per Case" ? true : false}
          />
        );
      }

      if (activeTab === "Throughput") {
        return <GroupedBarMultipleLineChart {...chartProps} />;
      }
    }

    if (Module === "DOM") {
      if (activeTab === "COF") {
        return (
          <BarChart
            {...chartProps}
            yAxisTitle={
              activeTab === "COF" ? "Fulfillment%" : "Diverts This Month"
            }
            showAnnotation={activeTab === "COF" ? true : false}
            type="DOM"
          />
        );
      } else {
        return <DPBarMultiple graphData={graphData} activeTab={activeTab} />;
      }
    }
    return <GroupedBarLineChart graphData={graphData} />;
  };
  const activeTabisOutorThro =
    activeTab === "Outbound Utilization" || activeTab === "Throughput";
  const getOrdinalSuffix = (day) => {
    const suffixes = ["th", "st", "nd", "rd"];
    const value = day % 100;
    return suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0];
  };
  const getTooltipTitle = (item) => {
    switch (item) {
      case "COF":
        return `From DOM - COF when the recommendations are not implemented and after the order diverts were implemented. <br />
                Filters applicable: Start and End date, Network and DCs`;

      case "Cost per Case":
        return `From Transportation data - Total transport cost incurred for total cases shipped to customers in the given time period <br />
                Filters applicable: Start and End date, Network and DCs`;

      case "Cost Reductions":
        return `From DOM - Total cost savings achieved based on implementation of divert recommendations <br />
                Filters applicable: Start and End date, Network and DCs`;

      case "Outbound Utilization":
        return `From Warehouse capacity & OVTR - Available outbound dock capacity from Warehouse capacity with corrections to match data from transporeon. <br /> OVTR data for actual booking <br />
                Filters applicable: Start and End date, Network and DCs`;

      case "Throughput":
        return `
        From DPAhistorical, OTR and Warehouse dock capacity - <br />
          1. Forecast is the Consensus Demand from DPAhistorical <br />
          2. Actuals are the sum of NPS for each date <br />
          3. Outbounds/Inbouds - # of outbond/inbound slots available * conversion for each slot. <br />
          <br />
          Conversion values - <br />
          Ambient -  $125K/slot<br />
          Chilled- $60K/slot<br />
          Frozen- $110K/slot<br />
          NPW- $30K/sot<br />
          <br />
          Filters applicable: Start and End date, Network and DCs`;
      case "Recommended Diverts":
        return `From DOM - Number of diverts recommended.<br />
          Filters applicable: Start and End date, Network and DCs`;

      // Add more cases as needed for each KPI
      default:
        return "This is additional information about the KPI";
    }
  };

  return (
    <>
      {loading ? (
        <div className={classes.loader}>
          <Loading />
        </div>
      ) : (
        <>
          {/* <div className={classes.main}>
                        <div className={classes.appBar}> */}
          <Box
            sx={{
              maxWidth: "70vw",
              overflow: "hidden",
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChange}
              className={classes.tab}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
              ScrollButtonComponent={CustomScrollButton}
              classes={{ indicator: classes.indicator }}
            >
              {graphViewTabList.map((item, index) => (
                <Tab
                  key={index}
                  className={
                    tabValue === index
                      ? classes.activeTabs
                      : classes.inActiveTabs
                  }
                  label={item.name}
                  style={{
                    minHeight: "35px",
                  }}
                  {...a11yProps(index)}
                />
              ))}
            </Tabs>
          </Box>
          {/* </div>
                    </div> */}
          {graphViewTabList.map((_item, index) => (
            <TabPanel key={index} value={tabIndex} index={index}>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent={activeTabisOutorThro && "space-between"}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Select
                    value={topOrBottomValue}
                    onChange={handleTopBottomChange}
                    className={classes.select}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                    //sx={classes.select}
                  >
                    <MenuItem value="Top">
                      {activeTab === "Outbound Utilization"
                        ? `Next`
                        : activeTab === "Throughput"
                          ? "This Month"
                          : "Top"}
                    </MenuItem>
                    <MenuItem
                      value={
                        activeTab === "Outbound Utilization"
                          ? `Previous`
                          : activeTab === "Throughput"
                            ? "Previous Month"
                            : "Bottom"
                      }
                    >
                      {activeTab === "Outbound Utilization"
                        ? `Previous`
                        : activeTab === "Throughput"
                          ? "Previous Month"
                          : "Bottom"}
                    </MenuItem>
                  </Select>
                  {activeTab !== "Throughput" && (
                    <Select
                      value={countValue}
                      onChange={handleCountChange}
                      className={classes.select}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      //sx={classes.select}
                    >
                      {countList.map((item, _index) => (
                        <MenuItem key={item} value={item}>
                          {activeTab === "Outbound Utilization"
                            ? `${item} Days`
                            : item}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Radio
                      value="Network"
                      checked={selectedRadioValue === "Network"}
                      onChange={() => handleRadioChange("Network")}
                      size="small"
                      inputProps={{ "aria-label": "Network" }}
                      sx={{
                        color: "#359DD0 !important",
                        "&.Mui-checked": {
                          color: "#359DD0 !important",
                        },
                      }}
                    />
                    <span
                      className={classes.filter}
                      style={{
                        display: "flex", // Ensures the text and icon are on the same line
                        alignItems: "center", // Vertically aligns the text and icon
                        color:
                          selectedRadioValue ===
                          (Module === "SNO" ? "Overall" : "Network")
                            ? "#359DD0"
                            : "#359DD0",
                      }}
                    >
                      {Module === "SNO" ? "Overall" : "Network"}
                      <Tooltip
                        title={
                          <span
                            dangerouslySetInnerHTML={{
                              __html: getTooltipTitle(activeTab),
                            }}
                          />
                        }
                        placement="top"
                      >
                        <InfoOutlinedIcon
                          fontSize="small"
                          style={{
                            color: "blue",
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </span>
                  </div>
                </div>
                {activeTabisOutorThro && graphDate?.latestDate && (
                  <div style={{ fontSize: "small" }}>
                    {(() => {
                      const date = new Date(graphDate.latestDate);
                      const day = date.getDate();
                      const month = date.toLocaleString("en-GB", {
                        month: "short",
                      });
                      const year = date.toLocaleString("en-GB", {
                        year: "2-digit",
                      });

                      return `${day}${getOrdinalSuffix(day)} ${month}, ${year}`;
                    })()}
                  </div>
                )}
              </Stack>
              {renderChart()}
            </TabPanel>
          ))}
        </>
      )}
    </>
  );
};

GraphViewSNO_DOM.propTypes = {
  tabIndex: PropTypes.number.isRequired,
  tabChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  PL3: state.filter.PL3,
  date: state.filter.Date,
  Division: state.filter.Division,
  applyFilter: state.filter.applyFilter,
  role: state.login.role,
});

const mapDispatchToProps = (dispatch) => ({
  tabChange: (newValue) => dispatch({ type: "TAB_INDEX", payload: newValue }),
  moduleTabIndexChange: (newValue) =>
    dispatch({ type: "MODULE_TAB_INDEX", payload: newValue }),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphViewSNO_DOM);
